import { Component, Input, OnChanges } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-kpp-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
})
export class KppErrorMessageComponent implements OnChanges {
  @Input() validationErrors: ValidationErrors | null;
  @Input() type: string | null = 'default';
  @Input() errorNumber = 0;
  errors: string[] = [];

  constructor(private readonly translate: TranslateService) {}

  ngOnChanges(): void {
    const objKeys: any = Object.keys(this.validationErrors ?? {});
    this.errors = [];
    objKeys.forEach((key: any) => {
      switch (key) {
        case 'maxlength': {
          const maxLength = this.validationErrors?.[key].requiredLength;
          this.errors.push(this.translate.instant('kppFormErrors.maxLength', { requiredLength: maxLength }));
          break;
        }
        case 'objectValueRequired': {
          this.errors.push(this.translate.instant('kppFormErrors.required.all'));
          break;
        }
        case 'requiredTrue':
        case 'required': {
          if (this.type === 'table') {
            this.errors.push(this.translate.instant('kppFormErrors.required.table'));
            return;
          }
          this.errors.push(this.translate.instant('kppFormErrors.required.default'));
          break;
        }
        case 'minlength': {
          const minLength = this.validationErrors?.[key].requiredLength;
          this.errors.push(this.translate.instant('kppFormErrors.minLength', { requiredLength: minLength }));
          break;
        }
        case 'patternMismatch':
        case 'pattern': {
          this.errors.push(this.translate.instant('kppFormErrors.pattern.default'));
          break;
        }
        case 'arrayUniqueValidator': {
          this.errors.push(this.translate.instant('kppFormErrors.arrayUnique'));
          break;
        }
        case 'minChoices': {
          const min = this.validationErrors?.[key].min;
          this.errors.push(this.translate.instant('kppFormErrors.minChoices.default', { min }));
          break;
        }
        case 'maxChoices': {
          const max = this.validationErrors?.[key].max;
          this.errors.push(this.translate.instant('kppFormErrors.maxChoices', { max }));
          break;
        }
        case 'arrayLength': {
          const requiredLength = this.validationErrors?.[key].requiredLength;
          const actualLength = this.validationErrors?.[key].actualLength;
          const remainingLength = requiredLength - actualLength;

          if (this.type === 'file_upload') {
            this.errors.push(this.translate.instant('kppFormErrors.arrayLength.file', { remainingLength }));
          } else {
            this.errors.push(this.translate.instant('kppFormErrors.arrayLength.default', { requiredLength }));
          }
          break;
        }
        case 'passwordMismatch': {
          this.errors.push(this.translate.instant('kppFormErrors.passwordMismatch'));
          break;
        }
        case 'maxCheckboxLimitExceeded': {
          const limit = this.validationErrors?.[key].limit;
          this.errors.push(this.translate.instant('kppFormErrors.maxCheckboxLimitExceeded', { limit }));
          break;
        }
        case 'exclusiveCategorySelection': {
          this.errors.push(this.translate.instant('kppFormErrors.exclusiveCategorySelection'));
          break;
        }
        case 'atLeastOneValueRequired': {
          this.errors.push(this.translate.instant('kppFormErrors.required.category'));
          break;
        }
        case 'customDateRange': {
          const message = this.validationErrors?.['message'];
          this.errors.push(message);
          break;
        }
        case 'serverError': {
          this.errors.push(this.validationErrors?.[key]);
          break;
        }
        case 'screenValuesMissing': {
          const screen2Required = this.validationErrors?.['screen2Req'];
          const screen3Required = this.validationErrors?.['screen3Req'];
          const saveButtonReq = this.validationErrors?.['saveButtonReq'];
          let message = '';

          if (saveButtonReq) {
            message = 'Kérem kattintson a küldőpiacok mentése gombra!';
          } else {
            message = 'Kérem válasszon minden országhoz preferenciát az alábbi ';

            if (screen2Required && screen3Required) {
              message += 'Programtípusok és Kiemelt Turisztikai Desztinációk';
            } else if (screen2Required) {
              message += 'Programtípusok';
            } else if (screen3Required) {
              message += 'Kiemelt Turisztikai Desztinációk';
            }

            message += ' közül és kattintson a Preferenciák mentése gombra!';
          }

          this.errors.push(message);
        }
      }
    });
  }
}